import moment from 'moment';
import db from '@/store/db';
import log from '@/logger';

export default {
  getDefaultPart: (projectId) => {
    return {
      title: 'New Part',
      projectId: projectId,
      type: 'Part',
      startdate: moment().format('YYYY-MM-DD'),
      time: 1,
      calendarTime: 1,
      deliverydate: '0000-01-01',
      deliveryFulfilled: false,
      deliveryText: '',
      controldate: moment().format('YYYY-MM-DD'),
      controlFulfilled: false,
      controlText: '',
      expectedDonedate: moment().format('YYYY-MM-DD'),
      archived: false,
      lastUpdate: {},
      text: '',
      colour: '#5555ee',
      workHours: 0,
      partManagerId: '',
      partOccupation: '',
      partSubcontractorId: '',
      createdAt: moment().format(),
    };
  },
  createPart: function (projectId, newPartProperties) {
    // console.log('api:createPart');

    if (
      newPartProperties.startdate &&
      (!newPartProperties.expectedDonedate || newPartProperties.startdate > newPartProperties.expectedDonedate)
    ) {
      newPartProperties.expectedDonedate = newPartProperties.startdate;
    }
    var newPart = Object.assign({}, this.getDefaultPart(projectId), newPartProperties);

    // In case we are copying a whole part
    delete newPart._id;
    delete newPart._rev;

    return db.currentProjectDb.post(newPart).then(function (doc) {
      newPart._id = doc.id;
      newPart._rev = doc.rev;
      return newPart;
    });
  },
  savePart: function (part) {
    var savedPart = {};
    if (part._id) {
      return db.currentProjectDb.put(part).then((response) => {
        savedPart._rev = response.rev;
        return savedPart;
      });
    } else {
      return db.currentProjectDb.post(part).then((response) => {
        return response;
      });
    }
  },

  getParts: function (projectId) {
    return db.loadedDatabases[projectId]
      .query('parts', {
        include_docs: true,
        startkey: [projectId, ''],
        endkey: [projectId, '\ufff0'],
      })
      .then((result) => {
        var populated = {};
        for (var part of result.rows) {
          part = Object.assign(this.getDefaultPart(projectId), part.doc);
          part.startdate = moment(part.startdate).format('YYYY-MM-DD');

          populated[part._id] = part;
        }

        return populated;
      })
      .catch(function (err) {
        log.error('Unable to load parts', err);
      });
  },

  getPart: async function (id) {
    if (!db.currentProjectDb.get) {
      return;
    }
    return db.currentProjectDb.get(id);
  },
};



// WEBPACK FOOTER //
// ./src/store/part/partApi.js